var DEFAULT_PASSWORD_HINTS = ['tooShort', 'missingNumberOrSymbol'];
var DIGIT_REG_EX = /\d/;
var DOUBLE_BYTE_REG_EX = /[^\u0000-\u00ff]/;
var FOUR_CHAR_SEQUENCES = ['`1231234234534564567567867897890890-90-=', 'qwerwertertyrtyutyuiyuiouiopiop[op[]p[]\\', "asdfsdfgdfghfghjghjkhjkljkl;kl;'", 'zxcvxcvbcvbnvbnmbnm,nm,.m,./', '~!@#!@#$@#$%#$%^$%^&%^&*^&*(&*()*()_()_+', 'QWERWERTERTYRTYUTYUIYUIOUIOPIOP{OP{}P{}|', 'ASDFSDFGDFGHFGHJGHJKHJKLJKL:KL:"', 'ZXCVXCVBCVBNVBNMBNM<NM<>M<>?'].join(' ');
var FOUR_REPEATED_REG_EX = /(.)\1{3}/;
var MAX_HINTS = 5;
var NON_VALID_CHARS_REG_EX = /[\x00-\x08\x0E-\x1F\x80-\xFF ]/;
var PASSWORD_HINT_KEYS = ['tooShort', 'tooLong', 'missingNumberOrSymbol', 'hasFourCharSequence', 'hasFourCharRepeated', 'hasNonValidChars', 'hasNonValidSymbol', 'hasDoubleByte', 'infoSecViolation'];
var PASSWORD_HINT_MAP = {
  hasDoubleByte: {
    name: 'noDoubleByte',
    type: 'restriction'
  },
  hasFourCharRepeated: {
    name: 'fourRepeatedChars',
    type: 'restriction'
  },
  hasFourCharSequence: {
    name: 'fourConsecutiveChars',
    type: 'restriction'
  },
  hasNonValidChars: {
    name: 'noInvalidChars',
    type: 'restriction'
  },
  hasNonValidSymbol: {
    name: 'noInvalidSymbol',
    type: 'restriction'
  },
  infoSecViolation: {
    name: 'infoSec',
    type: 'restriction'
  },
  missingNumberOrSymbol: {
    name: 'specialChar',
    type: 'requirement'
  },
  tooLong: {
    name: 'tooLong',
    type: 'requirement'
  },
  tooShort: {
    name: 'tooShort',
    type: 'requirement'
  }
};
var PROPS_TO_FILTER = ['allowHints', 'allowRawValue', 'ariaLabelledBy', 'autoComplete', 'blurHandler', 'changeHandler', 'containerStyleOverrides', 'countryCode', 'displayError', 'error', 'focusHandler', 'hintsContent', 'hintsStyleOverrides', 'id', 'inputStyleOverrides', 'name', 'required', 'showButtonAriaLabel', 'showButtonContent', 'showButtonIcon', 'type', 'value'];
var SYMBOL_REG_EX = /[!@#$%^&*()+~=\\]/;
var NON_VALID_SYMBOL_REG_EX = /[-?_|`{}[\]:';'<>,./]/;
export { DEFAULT_PASSWORD_HINTS, DIGIT_REG_EX, DOUBLE_BYTE_REG_EX, FOUR_CHAR_SEQUENCES, FOUR_REPEATED_REG_EX, MAX_HINTS, NON_VALID_CHARS_REG_EX, NON_VALID_SYMBOL_REG_EX, PASSWORD_HINT_KEYS, PASSWORD_HINT_MAP, PROPS_TO_FILTER, SYMBOL_REG_EX };